import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Label,
  Input,
  FormGroup,
} from "reactstrap";
import { showToast } from "../../helper-methods";
import { forStatus } from "../../http/http-calls";

const CommissionPercentageModal = ({
  isOpen,
  toggle,
  groupCommision,
  fetchAllGroups,
}) => {
  console.log("GROUP COMMISSION", groupCommision);
  const _closeModal = () => {
    toggle();
    setFormData({
      commissionCharge: "",
      transactionFee: "",
    });
    setIsDirty({
      commissionCharge: false,
      transactionFee: false,
    });
    setErrors({});
  };

  /* eslint-disable */

  useEffect(() => {
    if (groupCommision) {
      setFormData({
        ...formData,
        commissionCharge: groupCommision?.memberCommission,
        transactionFee: groupCommision?.transactionFee,
      });
      setPrevData({
        ...formData,
        commissionCharge: groupCommision?.memberCommission,
        transactionFee: groupCommision?.transactionFee,
      });
    }
  }, [groupCommision]);

  const [formData, setFormData] = useState({
    commissionCharge: "",
    transactionFee: "",
  });
  const [isDirty, setIsDirty] = useState({
    commissionCharge: false,
    transactionFee: false,
  });
  const [errors, setErrors] = useState({});

  const [prevData, setPrevData] = useState({
    commissionCharge: "",
    transactionFee: "",
  });

  const _handelOnChange = (field, event) => {
    const newFormData = { ...formData };
    const newIsDirty = { ...isDirty };
    newFormData[field] = event.target.value;
    newIsDirty[field] = true;
    setFormData(newFormData);
    setIsDirty(newIsDirty);
    _validateForm(newFormData, newIsDirty);
  };

  const _validateForm = (data, dirties) => {
    const newErrors = { ...errors };

    Object.keys(dirties).forEach((each) => {
      if (
        (each === "commissionCharge" || each === "transactionFee") &&
        dirties[each]
      ) {
        if (
          data[each] === "" ||
          (typeof data[each] === "string" && !data[each].trim())
        ) {
          newErrors[each] = "*Required";
        } else {
          delete newErrors[each];
          dirties[each] = false;
        }
      }
    });
    setIsDirty(dirties);
    setErrors(newErrors);
    return Object.keys(newErrors).length ? true : false;
  };

  const _submitHandler = async () => {
    const newIsDirty = { ...isDirty };
    Object.keys(isDirty).forEach((each) => (newIsDirty[each] = true));
    const error = _validateForm(formData, newIsDirty);
    // console.log("errors => ", error);
    if (!error) {
      console.log("formdata", formData);
      try {
        const res = await forStatus(groupCommision?.id, {
          memberCommission: Number(formData?.commissionCharge),
          transactionFee: Number(formData?.transactionFee),
        });
        console.log("groupCommision>>", res);
        fetchAllGroups();
        _closeModal();
      } catch (error) {
        // console.log(error);
        showToast(error?.reason, "error");
      }
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={() => _closeModal()} scrollable centered>
      <ModalHeader toggle={() => _closeModal()}>
        Customize Commission Percentage and Transaction Fee
      </ModalHeader>
      <ModalBody>
        <FormGroup className="mt-2">
          <Label>Commission Charge</Label>
          <InputGroup>
            <Input
              placeholder="Enter"
              type="number"
              value={formData?.commissionCharge}
              onChange={(event) => _handelOnChange("commissionCharge", event)}
            />
            <InputGroupText>
              <i className="fas fa-percentage" />
            </InputGroupText>
          </InputGroup>
          {errors.commissionCharge ? (
            <div className="form-error">{errors.commissionCharge}</div>
          ) : null}
        </FormGroup>
        <FormGroup className="mt-2">
          <Label>Transaction Fee</Label>
          <InputGroup>
            <Input
              placeholder="Enter"
              type="number"
              value={formData?.transactionFee}
              onChange={(event) => _handelOnChange("transactionFee", event)}
            />
            <InputGroupText>
              <i className="fas fa-dollar-sign" />
            </InputGroupText>
          </InputGroup>
          {errors.transactionFee ? (
            <div className="form-error">{errors.transactionFee}</div>
          ) : null}
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="link" className="closeBtn" onClick={() => _closeModal()}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => _submitHandler()}
          disabled={JSON.stringify(prevData) === JSON.stringify(formData)}
        >
          Update
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CommissionPercentageModal;
